// ** Auth Endpoints
export default {
  loginEndpoint: 'api/login',
  registerEndpoint: 'api/register',
  refreshEndpoint: 'api/refresh-token',
  logoutEndpoint: 'api/logout',
  resetPasswordEndpoint: 'api/reset-password',

  // 2FA
  twoFactorSecretGenerateEndpoint: 'api/2fa/secret/generate',
  twoFactorEnableEndpoint: 'api/2fa/enable',
  twoFactorDisableEndpoint: 'api/2fa/disable',
  twoFactorVerifyEndpoint: 'api/2fa/verify',

  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  storageTokenKeyName: '_accessToken',
  storageRefreshTokenKeyName: '_refreshToken',

  storageUserDataKeyName: '_userData',
}
